import { staticGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createSampledSegment = {
  name: "createSampledSegment" as const,
  input: z.object({
    customerGroupId: zExt.objectId(),
    sampleSize: z.number().min(1).default(1000),
    name: z.string(),
  }),
  output: staticGroupSchema,
};
